import React from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from 'components/Icon'
import { Mutation, ApolloConsumer } from 'react-apollo'
import { TOGGLE_AUTH } from 'operations/Auth'
import { withRouter } from 'react-router'
import './nav.css'

export const Nav = withRouter((props) => {

    return(
        <nav className='nav__container'>
            <ul>
                <li><NavLink exact to='/'><Icon icon='dashboard'/>Dashboard</NavLink></li>
                <li><NavLink to='/images'><Icon icon='photo'/>Images</NavLink></li>
                <li><NavLink to='/settings'><Icon icon='settings'/>Settings</NavLink></li>
                <li><NavLink to='/account'><Icon icon='account_box'/>Account</NavLink></li>
                <li><Mutation mutation={ TOGGLE_AUTH }>
                    {(toggleAuth, { data }) => (
                        
                        <ApolloConsumer>
                            {client => (

                                <button onClick={
                                    () => {
                                        toggleAuth({ variables: { isAuthenticated: false } })
                                        .then(() => {
                                            localStorage.removeItem('accessToken')
                                            localStorage.removeItem('refreshToken')
                                            localStorage.removeItem('tokenExpiry')
                                            client.resetStore()
                                            props.history.push('/')
                                        })
                                    }
                                }><Icon icon='exit_to_app'/>Log Out</button>

                            )}
                        </ApolloConsumer>
                        
                    )}
                </Mutation></li>
            </ul>
        </nav>
    )

})


// WEBPACK FOOTER //
// ./src/components/Nav/index.js